import React from "react";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router";
import { ModalHeaderProps } from "reactstrap";

import { AVAILIO_LOGO } from "@constants/assets";
import modalSlice from "@slices/modal.slice";
import { RootState } from "@store/index";

const ModalHeader: React.FC<ModalHeaderProps> = ({ onClose }) => {
  const dispatch = useDispatch();

  const { memberListing, registerModal } = useSelector(
    (state: RootState) => state.modal
  );

  const closeModal = () => {
    if (memberListing) dispatch(modalSlice.actions.updateMemberListing(false));
    if (registerModal) dispatch(modalSlice.actions.updateRegisterModal(false));
  };

  return (
    <div className="fg-modal-header-main p-3 pb-0">
      <button
        className="fg-close-btn"
        data-testid="closeButton"
        aria-label="Close"
        onClick={() => {
          if (onClose) onClose(false);
        }}
      >
        <i className="fa-sharp fa-solid fa-xmark fa-xl"></i>
      </button>
      <div
        className="container-fluid fg-z-index-1 position-relative"
        data-testid="modalHeader"
      >
        <div className="fg-logo-within-shape p-3">
          <Link to={"/"} onClick={closeModal}>
            <img
              src={AVAILIO_LOGO}
              className="fg-logo-img"
              alt={t("availioTitle")}
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ModalHeader;
